'use client';

import { FingerprintProvider as FpProvider } from '@fingerprint/react';
interface FingerprintProviderProps {
  children: React.ReactNode;
}
const proxyUrl = process.env.NEXT_PUBLIC_FPJS_PROXY_URL;
export function FingerprintProvider({
  children
}: FingerprintProviderProps) {
  const apiKey = process.env.NEXT_PUBLIC_FINGERPRINT_API_KEY;
  if (!apiKey) {
    return <>{children}</>;
  }
  return <FpProvider apiKey={apiKey} endpoints={proxyUrl ? [proxyUrl] : undefined} data-sentry-element="FpProvider" data-sentry-component="FingerprintProvider" data-sentry-source-file="fingerprint-provider.tsx">
      {children}
    </FpProvider>;
}